import { forwardRef, type Ref, type SVGProps } from "react";
const IconTagDollarSignOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M28.001 2h-10a1.97 1.97 0 0 0-1.41.59l-14 14a1.974 1.974 0 0 0 0 2.82l10 10a1.98 1.98 0 0 0 2.82 0l14-14a1.97 1.97 0 0 0 .59-1.41V4a2.006 2.006 0 0 0-2-2m0 12-14 14-10-10 14-14h10Z" />
    <path d="M22.001 8a2 2 0 1 0 0 4 2 2 0 1 0 0-4" />
    <path d="m14.681 17.503-1.037-.242c-.896-.238-1.295-.606-1.295-1.192 0-.615.538-1.051 1.329-1.137a1.99 1.99 0 0 1 1.894.983.7.7 0 0 0 .653.423c.355 0 .576-.19.576-.494a1.2 1.2 0 0 0-.052-.325 2.54 2.54 0 0 0-2.285-1.591v-.261a.645.645 0 1 0-1.29 0v.294a2.31 2.31 0 0 0-2.144 2.265c0 1.153.714 1.856 2.246 2.212l1.019.242c1.015.263 1.393.593 1.393 1.219 0 .678-.525 1.118-1.402 1.177a2.13 2.13 0 0 1-2.058-.997.64.64 0 0 0-.62-.432.54.54 0 0 0-.607.567 1 1 0 0 0 .06.325 2.49 2.49 0 0 0 2.117 1.514v.285a.645.645 0 1 0 1.29 0v-.254C15.726 21.95 17 21.272 17 19.711c0-1.166-.693-1.827-2.32-2.208Z" />
  </svg>
);
const ForwardRef = forwardRef(IconTagDollarSignOutlineSVG);
ForwardRef.displayName = "IconTagDollarSignOutline";
export { ForwardRef as IconTagDollarSignOutline };
